// NuvaSleep — JS propio, vanilla, un init por componente.
document.addEventListener('DOMContentLoaded', function () {
  initReveal();
  initComparador();
  initResenasCarrusel();
  initFaq();
  initCifras();
  initGaleriaProducto();
  initVariantes();
  initCantidad();
});

function initReveal() {
  var els = document.querySelectorAll('.lt-reveal');
  if (!els.length) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    els.forEach(function (el) { el.classList.add('lt-visible'); });
    return;
  }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('lt-visible');
        io.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -60px 0px' });
  els.forEach(function (el) { io.observe(el); });
}

function initComparador() {
  document.querySelectorAll('[data-lt-comparador]').forEach(function (wrap) {
    var antes = wrap.querySelector('.lt-comparador__antes');
    var handle = wrap.querySelector('.lt-comparador__handle');
    var antesImg = antes.querySelector('img');
    if (!antes || !handle) return;

    function setPos(pct) {
      pct = Math.max(0, Math.min(100, pct));
      antes.style.width = pct + '%';
      handle.style.left = pct + '%';
      if (antesImg) antesImg.style.width = (10000 / pct) + '%';
    }
    setPos(50);

    var dragging = false;
    function pctFromEvent(e) {
      var rect = wrap.getBoundingClientRect();
      var x = (e.touches ? e.touches[0].clientX : e.clientX) - rect.left;
      return (x / rect.width) * 100;
    }
    wrap.addEventListener('pointerdown', function (e) { dragging = true; setPos(pctFromEvent(e)); });
    window.addEventListener('pointermove', function (e) { if (dragging) setPos(pctFromEvent(e)); });
    window.addEventListener('pointerup', function () { dragging = false; });
  });
}

function initResenasCarrusel() {
  document.querySelectorAll('[data-lt-resenas]').forEach(function (block) {
    var track = block.querySelector('.lt-resenas__track');
    var prev = block.querySelector('[data-lt-prev]');
    var next = block.querySelector('[data-lt-next]');
    if (!track) return;
    function scrollByCard(dir) {
      var card = track.querySelector('.lt-resena');
      var gap = 20;
      var amount = card ? (card.offsetWidth + gap) * dir : 320 * dir;
      track.scrollBy({ left: amount, behavior: 'smooth' });
    }
    if (prev) prev.addEventListener('click', function () { scrollByCard(-1); });
    if (next) next.addEventListener('click', function () { scrollByCard(1); });
  });
}

function initFaq() {
  document.querySelectorAll('.lt-faq__item').forEach(function (item) {
    var btn = item.querySelector('.lt-faq__pregunta');
    var panel = item.querySelector('.lt-faq__respuesta');
    if (!btn || !panel) return;
    btn.addEventListener('click', function () {
      var abierto = item.classList.contains('lt-abierto');
      item.parentElement.querySelectorAll('.lt-faq__item').forEach(function (i) {
        i.classList.remove('lt-abierto');
        i.querySelector('.lt-faq__respuesta').style.maxHeight = null;
      });
      if (!abierto) {
        item.classList.add('lt-abierto');
        panel.style.maxHeight = panel.scrollHeight + 'px';
      }
    });
  });
}

function initCifras() {
  var els = document.querySelectorAll('[data-lt-cifra]');
  if (!els.length) return;
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var el = entry.target;
      var target = parseFloat(el.getAttribute('data-lt-cifra'));
      var suffix = el.getAttribute('data-lt-sufijo') || '';
      var dur = 1400;
      var start = null;
      function step(ts) {
        if (!start) start = ts;
        var progress = Math.min((ts - start) / dur, 1);
        var eased = 1 - Math.pow(1 - progress, 3);
        var val = target < 10 ? (target * eased).toFixed(1) : Math.round(target * eased);
        el.textContent = val + suffix;
        if (progress < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
      io.unobserve(el);
    });
  }, { threshold: 0.5 });
  els.forEach(function (el) { io.observe(el); });
}

function initGaleriaProducto() {
  document.querySelectorAll('[data-lt-galeria]').forEach(function (galeria) {
    var principal = galeria.querySelector('[data-lt-galeria-principal]');
    var minis = galeria.querySelectorAll('[data-lt-mini]');
    if (!principal || !minis.length) return;
    minis.forEach(function (mini) {
      mini.addEventListener('click', function () {
        var src = mini.getAttribute('data-full');
        var alt = mini.getAttribute('data-alt') || '';
        var img = principal.querySelector('img');
        if (img) { img.src = src; img.alt = alt; }
        minis.forEach(function (m) { m.classList.remove('lt-activa'); });
        mini.classList.add('lt-activa');
      });
    });
  });
}

function initVariantes() {
  document.querySelectorAll('[data-lt-producto-form]').forEach(function (form) {
    var variantsData = form.querySelector('[data-lt-variantes]');
    if (!variantsData) return;
    var variants = JSON.parse(variantsData.textContent);
    var idInput = form.querySelector('input[name="id"]');
    var precioEl = form.querySelector('[data-lt-precio]');
    var compareEl = form.querySelector('[data-lt-precio-comparado]');
    var comprarBtn = form.querySelector('[data-lt-comprar]');
    var opciones = form.querySelectorAll('[data-lt-opcion]');

    function seleccionActual() {
      var sel = [];
      opciones.forEach(function (grupo) {
        var activo = grupo.querySelector('.lt-activa');
        sel.push(activo ? activo.getAttribute('data-valor') : null);
      });
      return sel;
    }

    function actualizar() {
      var sel = seleccionActual();
      var match = variants.find(function (v) {
        return v.options.every(function (val, i) { return val === sel[i]; });
      });
      if (!match) return;
      idInput.value = match.id;
      if (precioEl) precioEl.textContent = match.precio;
      if (compareEl) {
        if (match.compareAt) { compareEl.textContent = match.compareAt; compareEl.style.display = ''; }
        else { compareEl.style.display = 'none'; }
      }
      if (comprarBtn) {
        comprarBtn.disabled = !match.disponible;
        comprarBtn.textContent = match.disponible ? comprarBtn.getAttribute('data-texto-disponible') : comprarBtn.getAttribute('data-texto-agotado');
      }
    }

    opciones.forEach(function (grupo) {
      grupo.querySelectorAll('[data-valor]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          grupo.querySelectorAll('[data-valor]').forEach(function (b) { b.classList.remove('lt-activa'); });
          btn.classList.add('lt-activa');
          actualizar();
        });
      });
    });

    actualizar();
  });
}

function initCantidad() {
  document.querySelectorAll('[data-lt-cantidad]').forEach(function (wrap) {
    var input = wrap.querySelector('input');
    var menos = wrap.querySelector('[data-lt-menos]');
    var mas = wrap.querySelector('[data-lt-mas]');
    if (!input) return;
    if (menos) menos.addEventListener('click', function () {
      input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
    });
    if (mas) mas.addEventListener('click', function () {
      input.value = (parseInt(input.value, 10) || 1) + 1;
    });
  });
}
